import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;

  .guidance-hotkey {
    font-size: 1em;
    color: #aaa;
    font-weight: bold;
    font-family: 'poppins', sans-serif;
    font-style: italic;
    margin-top: 10px;

    > div {
      margin: 8px 0;
    }
  }
`;
